import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../../../core/shared/http.service";
import { PixelSpaltenResultsResponse } from "../../project-settings/shared/data-end-channel-settings-dialog/interfaces/pixel-spalten-results-response";

@Injectable({
    providedIn: 'root'
})
export class DataPointService {
    constructor(private readonly httpService: HttpService) { }

    public getRouteStationPixelErrors(guid: string, dekanal: number, count?: number): Observable<PixelSpaltenResultsResponse> {
        return this.httpService.get<PixelSpaltenResultsResponse>('Datapoint/' + guid + '/pixelerrors/' + dekanal + '?count=' + count)
    }
}

